import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

ReactDOM.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>,
	document.getElementById('root')
);


//Built following the tutorials by Brian Design - https://www.youtube.com/channel/UCsKsymTY_4BYR-wytLjex7A